import { zodResolver } from '@hookform/resolvers/zod';
import type { DialogActionsProps } from '@mui/material';
import { TextField } from '@mui/material';
import {
  TriggerAnonymousCustomersReportJobParametersSchema,
  type TriggerAnonymousCustomersReportJobParameters,
  type TriggerReportJobRequestPayload,
} from '@vy/api-definition';
import { REPORT_JOB_TYPES } from '@vy/types';
import { useForm, FormProvider } from 'react-hook-form';

type TriggerReportJobDialogProps = {
  onSubmit: (payload: TriggerReportJobRequestPayload) => void;
  dialogActions: React.ReactElement<DialogActionsProps>;
};

export const TriggerAnonymousCustomersReportJobForm: React.FC<TriggerReportJobDialogProps> = ({
  onSubmit,
  dialogActions,
}) => {
  const methods = useForm<TriggerAnonymousCustomersReportJobParameters>({
    resolver: zodResolver(TriggerAnonymousCustomersReportJobParametersSchema),
    defaultValues: {
      reportJobType: REPORT_JOB_TYPES.AnonymousCustomers,
    },
  });

  const reportNameRegister = methods.register('reportName');
  const handleSubmit = methods.handleSubmit((data) => onSubmit(data));

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <div className="mt-3 flex flex-col items-start">
          <TextField {...reportNameRegister} className="w-full" placeholder="Report name" />
        </div>
        {dialogActions}
      </form>
    </FormProvider>
  );
};
